import { Tooltip } from '@material-ui/core';
import ActionButton, { MENU_BUTTON_CATEGORY } from 'src/components/UI/ActionButton';
import AddIcon from '@material-ui/icons/Add';
import { ButtonProps } from '@material-ui/core/Button/Button';
import { useSelector } from 'react-redux';
import { Store, useAppDispatch } from 'src/redux/Store';
import { MODALS } from 'src/models/ModalModel';
import { openModal } from 'src/redux/actions/modalActions';
import { t } from 'src/lib/language';

interface Props extends ButtonProps {
  eventId?: number;
}

const AddTicketButton = (props: Props) => {
  const { disabled, eventId } = props;
  const lang = useSelector((state: Store) => state.language.language ?? 'en');
  const dispatch = useAppDispatch();

  const handleOpen = () => {
    dispatch(openModal({
      modal: MODALS.addTicket,
      payload: { eventId },
    }));
  };

  return (
    <Tooltip
      title={t(lang, 'menus.add_ticket')}
      placement="top-start">
      <span>
        <ActionButton
          data-testid="add-ticket-button"
          variant="outlined"
          category={MENU_BUTTON_CATEGORY.action}
          onClick={handleOpen}
          disabled={disabled}>
          <AddIcon />
        </ActionButton>
      </span>
    </Tooltip>
  );
};

export default AddTicketButton;
